// @ts-nocheck
import React, { useState } from 'react'
import { useI18n } from '../../i18n/I18nContext';


const StarRating = ({ id, label, required, onInputChange }) => {
    const { t } = useI18n();
    const [rating, setRating] = useState(0);
    const handleInputChange = event => {
        setRating(Number(event.target.value));
        onInputChange(label, event.target.value);
    };

    return (
        <>
            <fieldset className="mb-6">
                <legend id={`rating-label-${id}`} className="block mb-2 text-sm font-medium text-gray-900">{label ? <span data-i18n-ignore="true">{label}</span> : t('Avaliação')}
                {required && <span className="text-red-500 text-xl"> *</span>}
</legend>
                <div className="flex flex-wrap gap-2" role="radiogroup" aria-labelledby={`rating-label-${id}`}>
                {[1, 2, 3, 4, 5].map((option) => (
                    <label key={option} className={`cursor-pointer rounded-xl border px-3 py-2 transition ${rating === option ? 'border-amber-400 bg-amber-50' : 'border-slate-200 bg-white hover:border-amber-300'}`}>
                        <input
                            type="radio"
                            id={`${id}-rating-${option}`}
                            name={id}
                            value={option}
                            onChange={handleInputChange}
                            required={required}
                            className="sr-only"
                        />
                        <span aria-hidden="true" className="text-lg text-amber-500">{'★'.repeat(option)}</span>
                        <span className="sr-only">{option} {t(option === 1 ? 'estrela' : 'estrelas')}</span>
                    </label>
                ))}
                </div>
            </fieldset>
        </>
    )
}

export default StarRating
